import React, { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const Services = () => {

    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const fetchServices = async () => {
            setIsLoading(true);  
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/services`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`); 
                }
                const data = await response.json();
                setServices(data);
            } catch (error) {
                console.error('Failed to fetch services:', error);
            } finally {
                setIsLoading(false); 
            }
        };

        fetchServices();
    }, [])

    let content;
    if(isLoading) {
        content = <div>Loading....</div>
    }
    if(!isLoading && services.length === 0) {
        content = <div>No Data Found</div>
    }
    if(!isLoading && services.length > 0) {
        content = services.slice(0, 4).map(service => <Link key={service._id} to={`/services/${service._id}`}>
            <div className="card  shadow-lg shadow-slate-600">
                <figure><img className="h-48 w-full" src={service?.slide1} alt="Shoes" /></figure>
                <div className="p-5">
                    <div className='flex gap-5 items-center'>
                        <div className="avatar online">
                            <div className="w-10 h-10 rounded-full">
                                <img src="https://i.ibb.co/dD7d8Kj/shijan.jpg" alt='' />
                            </div>
                        </div>
                        <div>
                            <h2 className='text-md'>Md Shijan Ali</h2>
                            <h2 className="text-[#FFBE5B] text-md font-semibold">Top Rated Seller</h2>
                        </div>
                    </div>

                    <p className='text-md mt-5'>{service?.title.slice(0, 60)}...</p>
                    <div className="divider"></div>
                    <div className='flex items-center justify-between'>
                        <div className='flex items-center gap-2'>
                            <FaStar className='text-[#FFBE5B]'></FaStar>
                            <p><span className='text-[#FFBE5B]'> 5.0</span> ({service?.review})</p>
                        </div>

                        <div>
                            <p>STARTING AT ${service?.pricingDetails?.basic?.price}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
        )
    }


    return (
        <div className=''>
            <div className='max-w-7xl mx-auto px-6 py-20'>
                    <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-5'>
                        {content}
                    </div>
            </div>
        </div>
    );
};

export default Services;